import { createAction } from 'redux-actions';

import { userSessionId } from 'app/features/user/selectors';
import { fetchUserData } from 'app/features/user/actions';
import { onAuthenticationRedirect } from 'app/features/authentication/actions/redirects';
import { authErrorHandler } from 'app/features/authentication/actions/helpers/authErrorHandler';
import { fetchDeltaConfig } from 'app/features/deltaConfig/actions';
import {
  REGISTRATION_SELECTED,
  REGISTRATION_REQUESTED,
  REGISTRATION_SUCCEEDED,
  REGISTRATION_FAILED,
} from 'app/features/authentication/actions/actionTypes';
import { validateCoupon } from 'app/features/couponCampaign/actions';

const registerApiErrorMap = {
  duplicate_object: 'flashmessage_error_registration_duplicate_account',
  bad_request: 'flashmessage_error_registration_bad_request',
  bad_session: 'flashmessage_error_registration_bad_request',
  internal_server_error: 'flashmessage_error_registration_bad_request',
};

const registrationSelected = createAction(REGISTRATION_SELECTED);
const registrationRequested = createAction(REGISTRATION_REQUESTED);
const registrationSucceeded = createAction(REGISTRATION_SUCCEEDED);
const registrationFailed = createAction(REGISTRATION_FAILED);

function registrationRequest({ username, ...rest }) {
  return (dispatch, getState, { api }) => {
    const state = getState();
    const sessionId = userSessionId(state);

    dispatch(registrationRequested({ emailAddress: username }));

    return api
      .register({ username, sessionId, ...rest })
      .then(response => {
        if (response.data.error) {
          return Promise.reject(response.data);
        }

        const emailAddress = username;
        const userId = response.data.user.etp_guid;

        dispatch(registrationSucceeded({ emailAddress, userId }));

        return dispatch(fetchUserData());
      })
      .then(() =>
        Promise.all([dispatch(fetchDeltaConfig()), dispatch(validateCoupon())]),
      )
      .then(() => dispatch(onAuthenticationRedirect()))
      .catch(error => {
        const failureReason = error.message;
        const emailAddress = username;

        dispatch(registrationFailed({ emailAddress, failureReason }));

        authErrorHandler({
          dispatch,
          map: registerApiErrorMap,
          defaultMessage: 'flashmessage_error_registration_bad_request',
        })(error);
      });
  };
}

export {
  registrationRequest,
  registrationSelected,
  registrationRequested,
  registrationSucceeded,
  registrationFailed,
};
